// Third-party
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps, Route, Redirect, Switch } from 'react-router-dom';

// HOC
import { ErrorBoundary } from '../../components/errors';

// Components
import FundScreenerPage from './pages/FundScreenerPage';
import SavedItemsPage from './pages/SavedItemsPage';

// Enums
import { SearchType } from '@/enums/AdvancedSearch';

// Utils
import { ADVANCED_SEARCH_OPTIONS } from '../../../utils/constants';
import { userHasPermission, PERMISSIONS } from '../../../utils/permissions';

// Actions
import { ReduxState } from '../../../redux/modules/types';

// Types
import Nullable from '@/types/nullable';
import User from '@/types/user';

// Components
import { Header } from '@/views/components/layout';

type StateProps = {
  user?: Nullable<User>;
};

type Props = RouteComponentProps & StateProps;

class Search extends Component<Props> {
  render() {
    const { user } = this.props;
    const hasBenchmarkPermission = !!user && userHasPermission(user, PERMISSIONS.BENCHMARKS);

    return (
      <ErrorBoundary>
        <Header />
        <div className="search-content">
          <Switch>
            <Route
              exact
              path={`${this.props.match.path}/`}
              render={(props: RouteComponentProps) => <FundScreenerPage {...props} className="all-items" useWindowScrollAncestor />}
            />

            <Route
              exact
              path={`${this.props.match.path}/funds`}
              render={(props: RouteComponentProps) => (
                <FundScreenerPage {...props} selectedOption={ADVANCED_SEARCH_OPTIONS.FUNDS} className="all-items" useWindowScrollAncestor />
              )}
            />

            {hasBenchmarkPermission && (
              <Route
                exact
                path={`${this.props.match.path}/benchmarks`}
                render={(props: RouteComponentProps) => (
                  <FundScreenerPage {...props} selectedOption={ADVANCED_SEARCH_OPTIONS.BENCHMARKS} className="all-items" useWindowScrollAncestor />
                )}
              />
            )}

            <Route
              path={`${this.props.match.path}/saved-funds`}
              render={(props: RouteComponentProps) => <SavedItemsPage {...props} itemType={SearchType.FUNDS} />}
            />

            {hasBenchmarkPermission && (
              <Route
                path={`${this.props.match.path}/saved-benchmarks`}
                render={(props: RouteComponentProps) => <SavedItemsPage {...props} itemType={SearchType.BENCHMARKS} />}
              />
            )}

            <Redirect to={this.props.match.path} />
          </Switch>
        </div>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = (state: ReduxState): StateProps => ({
  user: state.auth.user,
});

export default withRouter(connect(mapStateToProps)(Search));
